import type { ReactNode } from "react";

/**
 * Header padronizado de página, portado do monólito Manus.
 * Versão minimal — pode evoluir conforme necessário.
 */
export function PageHeader({
  title,
  subtitle,
  actions,
  action,
}: {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  /** Alias singular usado por algumas páginas portadas */
  action?: ReactNode;
}) {
  const acts = actions ?? action;
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 pb-4 mb-6 border-b border-zinc-200">
      <div>
        <h1 className="text-2xl font-bold text-zinc-900">{title}</h1>
        {subtitle && <p className="text-sm text-zinc-500 mt-1">{subtitle}</p>}
      </div>
      {acts && <div className="flex gap-2 flex-wrap">{acts}</div>}
    </div>
  );
}
